import { View, Text, StyleSheet, Dimensions } from 'react-native'
import { color, fontFamily } from '../../../theme'
import { TouchableOpacity } from 'react-native'

type ButtonEmojiProps = {
  emoji: string
  onPress: (emoji: string) => void
}

const WIDTH = Dimensions.get('screen').width
const isSmallDevice = WIDTH < 370 //small devices breakpoint

export const ButtonEmoji = ({ emoji, onPress }: ButtonEmojiProps) => {
  return (
    <TouchableOpacity onPress={() => onPress(emoji)}>
      <View style={[styles.container, isSmallDevice ? styles.smallEmojiSize : styles.defaultEmojiSize]}>
        <Text style={[styles.emoji, { fontSize: isSmallDevice ? 20 : 22 }]}>{emoji}</Text>
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 24,
    backgroundColor: color.palette.white,
    alignItems: 'center',
    justifyContent: 'center'
  },
  emoji: {
    fontFamily: fontFamily.FeatureDeckLight
  },
  defaultEmojiSize: {
    width: 40,
    height: 40
  },
  smallEmojiSize: {
    width: 38,
    height: 38
  }
})
